class Cookies {
    constructor() {}
    hasCookie(cookieName) {
        return document.cookie.match(new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*=\\s*([^;]*).*$)|^.*$`))[1] == "true";
    }
    setCookie(cookieName, cookieValue, expires) {
        const d = new Date();
        d.setTime(d.getTime() + (expires * 24 * 60 * 60 * 1000));
        document.cookie = `${cookieName}=${cookieValue};expires=${d.toUTCString()};path=/`;
    }
    getCookie(cookieName) {
        const name = `${cookieName}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
}

export default new Cookies;
